module.exports = __webpack_public_path__ + "static/img/login-alipay.d9c09fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/login-alipay.png
// module id = M1GS
// module chunks = 0